module.exports = __webpack_public_path__ + "static/media/Upload Image.0b507a33.svg";